import axios from "axios";

const api = "https://xilecloud.xilehd.top/index.php/api/";
// 查询在线状态和人数
export function getOnlineStatus(params) {
  return axios.get(api + "answerbs/online/status", {
    params,
    headers: {
      "site-id": "100006",
    },
  });
}

// 开始答题
export function startQuiz(id) {
  return axios.post(
    api + "answerbs/game/push_question",
    {},
    {
      params: { huodong_id: id },
      headers: { "site-id": "100006" },
    }
  );
}

// 本轮排名/本题排名
export function getRecordRank(params) {
  return axios.get(api + "answerbs/record/rank", {
    params,
    headers: {
      "site-id": "100006",
    },
  });
}
